import { NgModule } from '@angular/core';

import {
    RouterModule,
    Routes
} from '@angular/router';

// Components.
import { ArenaComponent } from './arena.component';
// Resolvers.
import { UserResolver } from '../shared-services.module/user.resolver';
import { ArenaOffersResolver } from './arena-offers.resolvers';

const routes: Routes = [{
    path: 'arena',
    component: ArenaComponent,
    resolve: {
        user: UserResolver,
        accessData: ArenaOffersResolver
    }
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [
        // Services.
        // Resolvers.
        UserResolver,
        ArenaOffersResolver
    ]
})
export class ArenaRoutingModule { }
